<template>

  <!-- Table Container Card -->
  <b-card
    title="Agenzie"
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <!-- <label>Entries</label> -->
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
          <b-button
            v-if="$can('create', 'Dealer')"
            variant="primary"
            @click="addEditAgencyModal(-1)"
          >
            Nuovo
          </b-button>
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              placeholder="Cerca..."
            />
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="refAgencyListTable"
      :items="fetchAgencies"
      responsive
      :fields="tableColumns"
      primary-key="Id"
      :sort-by.sync="sortBy"
      show-empty
      empty-text="No matching records found"
      :sort-desc.sync="isSortDirDesc"
      class="position-relative"
    >

      <template #head(company)>
        <feather-icon
          icon="BriefcaseIcon"
          class="mx-auto"
        /> Ragione Sociale
      </template>
      <template #head(address)>
        <feather-icon
          icon="MapPinIcon"
          class="mx-auto"
        /> Indirizzo
      </template>
      <template #head(contact)>
        <feather-icon
          icon="PhoneIcon"
          class="mx-auto"
        /> Contatto
      </template>
      <template #head(name)>
        <feather-icon
          icon="UserIcon"
          class="mx-auto"
        /> Referente
      </template>
      <template #head(actions)>
        <feather-icon
          icon="ZapIcon"
          class="mx-auto"
        /> Azioni
      </template>

      <!-- Column: Id -->
      <template #cell(provvigioniConfigurate)="data">
        <span
          v-if="data.item.provvigioniPersonalizzate=='N'"
          style="color: red;"
        >
          <feather-icon
            v-if="$can('create', 'Dealer')"
            :id="`alert-${data.item.Id}`"
            icon="AlertTriangleIcon"
            size="16"
            class="mx-1"
            :variant="Danger"
          />
        </span>
        <b-tooltip
          v-if="$can('write', 'Dealer')"
          :target="`alert-${data.item.Id}`"
          title="Provvigioni non settate"
        />
      </template>
      <template #cell(Id)="data">
        <b-link
          :to="{ name: 'agencyedit', params: { id: data.item.Id }}"
          class="font-weight-bold"
        >
          #{{ data.value }}
        </b-link>
      </template>

      <!-- Column: Client -->
      <template #cell(company)="data">
        <b-link
          :to="{ name: 'agencyedit', params: { id: data.item.Id }}"
          class="font-weight-bold"
        >
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.company)"
                variant="light-primary"
              />
            </template>
            <span class="font-weight-bold d-block text-nowrap">
              {{ data.item.company }}
            </span>
            <small class="text-muted">{{ data.item.companyEmail }}</small>
          </b-media>
        </b-link>
        <agency-add-modal
          :indexref="`${data.item.Id}`"
          :agency="data.item"
          @refetchData="refetchData"
        />
      </template>
      <!-- Column: Client -->
      <template #cell(address)="data">
        <b-media vertical-align="center">
          <span class="font-weight-bold d-block text-nowrap">
            {{ data.item.address }}
          </span>
          <small class="text-muted">{{ data.item.country }}</small>
        </b-media>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">

        <div class="text-nowrap">

          <feather-icon
            v-if="$can('write', 'Dealer')"
            :id="`agency-row-${data.item.Id}-edit-icon`"
            icon="EditIcon"
            size="16"
            class="mx-1"
            @click="addEditAgencyModal(data.item.Id)"
          />
          <b-tooltip
            v-if="$can('write', 'Dealer')"
            title="Modifica veloce"
            :target="`agency-row-${data.item.Id}-edit-icon`"
          />
          <!-- TODO Delete Agency
            <feather-icon
            v-if="$can('delete', 'Agency')"
            :id="`agency-row-${data.item.Id}-delete-icon`"
            icon="TrashIcon"
            size="16"
            class="mx-1"
            @click="deleteAgency(data.item.Id)"
          />
          <b-tooltip
            v-if="$can('delete', 'Agency')"
            title="Elimina"
            :target="`agency-row-${data.item.Id}-delete-icon`"
          /> -->
        </div>
      </template>

    </b-table>
    <div class="mx-2 mb-2">
      <b-row>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Vedi da {{ dataMeta.from }} a {{ dataMeta.to }} su {{ dataMeta.of }} elementi</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalAgencies"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
    <agency-add-modal
      indexref="-1"
      @refetchData="refetchData"
    />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,
} from 'bootstrap-vue'
// eslint-disable-next-line import/no-cycle
import { avatarText } from '@core/utils/filter'
import Vue from 'vue'
import vSelect from 'vue-select'
import { onUnmounted } from '@vue/composition-api'
import { useRouter } from '@core/utils/utils'
import store from '@/store'
import { getUserData } from '@/auth/utils'
import AgencyAddModal from './AgencyAddModal.vue'
import useAgenciesList from './useAgencyList'
import agencyStoreModule from './agencyStoreModule'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BPagination,
    BTooltip,

    vSelect,
    AgencyAddModal,
  },
  methods: {
    addEditAgencyModal(id) {
      this.$bvModal.show(`add-agency-${id}`)
    },
    deleteAgency(id) {
      // TODO
      console.log(`todo - delete ${id}`)
    },
  },
  setup() {
    const COMPANY_DEALER_STORE_MODULE_NAME = 'app-agency'
    const { route, router } = useRouter()
    const userData = getUserData()
    if (!Vue.prototype.$ability.can('create', 'Dealer')) {
      router.push({ name: 'agencyedit', params: { id: 'personal' } })
    }
    // Register module
    if (!store.hasModule(COMPANY_DEALER_STORE_MODULE_NAME)) { store.registerModule(COMPANY_DEALER_STORE_MODULE_NAME, agencyStoreModule) }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(COMPANY_DEALER_STORE_MODULE_NAME)) store.unregisterModule(COMPANY_DEALER_STORE_MODULE_NAME)
    })

    const {
      fetchAgencies,
      tableColumns,
      perPage,
      currentPage,
      totalAgencies,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refAgencyListTable,

      refetchData,

    } = useAgenciesList()

    return {
      fetchAgencies,
      tableColumns,
      perPage,
      currentPage,
      totalAgencies,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refAgencyListTable,

      refetchData,

      avatarText,
    }
  },
}
</script>

  <style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }

  .agency-filter-select {
    min-width: 190px;

    ::v-deep .vs__selected-options {
      flex-wrap: nowrap;
    }

    ::v-deep .vs__selected {
      width: 100px;
    }
  }
  </style>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>

